// Proof Key for Code Exchange (RFC 7636, S256): a secret the client makes and keeps, and
// the challenge the identity server holds for it. The code that comes back is worth
// nothing to anyone who lacks the secret.

function base64UrlOf(bytes) {
  let binary = '';
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export async function codeChallengeOf(codeVerifier) {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier));
  return base64UrlOf(new Uint8Array(digest));
}

/** A fresh verifier, and the challenge to send with the authorization request. */
export async function createPkcePair() {
  const bytes = new Uint8Array(32);
  crypto.getRandomValues(bytes);
  const codeVerifier = base64UrlOf(bytes);
  return { codeVerifier, codeChallenge: await codeChallengeOf(codeVerifier) };
}
